import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function setMatchOver(league_pk, round_pk, match_pk) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/${match_pk}/resolve_game_result/`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

